import React from "react";
import { FaFacebookF, FaInstagram, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-main page-width">
        <Link className="brand-link footer-brand" to="/">
          <span className="brand" aria-label="Dr. Tülay Yıldırım Estetik ve Güzellik">
            <span className="brand-mark" aria-hidden="true"><span>TY</span></span>
            <span className="brand-copy">
              <span className="brand-name">DR. TÜLAY YILDIRIM</span>
              <span className="brand-tagline">ESTETİK &amp; GÜZELLİK</span>
            </span>
          </span>
        </Link>

        <nav className="footer-nav" aria-label="Alt navigasyon">
          <Link to="/">Ana Sayfa</Link>
          <Link to="/hakkimizda">Hakkımızda</Link>
          <Link to="/">Hizmetlerimiz</Link>
          <Link to="/iletisim">İletişim</Link>
        </nav>

        <div className="footer-socials">
          <a
            href="https://www.facebook.com/profile.php?id=100076111957553"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.instagram.com/drtulayyildirim"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://wa.me/905304292306"
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a href="tel:+905304292306" aria-label="Telefon">
            <FaPhoneAlt />
          </a>
        </div>
      </div>
      <div className="footer-meta page-width">
        <p>Tevfikiye Mahallesi 3813 Sokak Öğretmenler Apartmanı No:31 İçkapı No:2, 45120 Yunusemre/Manisa</p>
        <p>GSM:0530 429 23 06</p>
      </div>
    </footer>
  );
};

export default Footer;
